export const AVATARS = [
  { id: "dahu", name: "大胡老师", src: "/avatars/dahu.png" },
  { id: "erhu", name: "二胡老师", src: "/avatars/erhu.png" },
  { id: "xiaoye", name: "小叶老师", src: "/avatars/xiaoye.png" },
  { id: "zhao", name: "赵老师", src: "/avatars/zhao.png" },
  { id: "ezai", name: "鹅崽", src: "/avatars/ezai.png" },
  { id: "xiaoyang", name: "小羊", src: "/avatars/xiaoyang.png" },
  { id: "zhuang", name: "壮老师", src: "/avatars/zhuang.png" },
  { id: "bang", name: "棒老师", src: "/avatars/bang.png" },
  { id: "hong", name: "红老师", src: "/avatars/hong.png" },
  { id: "juan", name: "卷", src: "/avatars/juan.png" },
  { id: "ajo", name: "阿jo", src: "/avatars/ajo.png" },
  { id: "yashua", name: "牙刷老师", src: "/avatars/yashua.png" },
] as const;

export type AvatarId = (typeof AVATARS)[number]["id"];

export const DEFAULT_AVATAR_ID: AvatarId = AVATARS[0].id;

export function validateAvatarId(value: unknown): value is AvatarId {
  return (
    typeof value === "string" &&
    AVATARS.some((avatar) => avatar.id === value)
  );
}

export function getAvatarById(value: unknown) {
  return AVATARS.find((avatar) => avatar.id === value);
}
